module.exports = __webpack_public_path__ + "img/HistoryShape.5baae1c8.svg";